
import AppModal from './AppModal.vue'

// Tempo de espera após o layout montar antes de exibir o popup, pra não
// competir com o carregamento inicial da página com o aluno logado.
const SHOW_DELAY_MS = 4000

export default {
  name: 'SurveyPopup',
  components: { AppModal },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    surveyEnabled() {
      return process.env.SURVEY_ENABLED === 'true'
    },
    user() {
      return this.$store.state.credential
    },
    surveyFormUrl() {
      return process.env.SURVEY_FORM_URL
    },
    surveyId() {
      return process.env.SURVEY_ID
    },
    surveyUrl() {
      if (!this.surveyFormUrl) {
        return null
      }
      // Jotform aceita prefill via query string usando o nome único do
      // campo. "nomeCompleto"/"email" continuam ocultos (hidden) na tela do
      // formulário — não é uma pesquisa anônima (o aluno já está numa área
      // logada), só não queremos poluir o form com campos que a gente já
      // sabe a resposta. Nome/e-mail vêm do Vuex (credential), que já é
      // populado pelo layout via GET /api/v1/academic/customer — o mesmo
      // endpoint que resolve o aluno real no banco, sem confiar no JWT
      // decodificado no client.
      const params = new URLSearchParams()
      params.set('nomeCompleto[first]', this.user.name || '')
      params.set('email', this.user.email || '')
      return `${this.surveyFormUrl}?${params.toString()}`
    },
    storageKey() {
      return `survey_dismissed_${this.surveyId}_${this.user.id}`
    },
  },
  mounted() {
    // SURVEY_ENABLED=false desliga o popup mesmo com tudo configurado — dá
    // pra pausar a pesquisa sem apagar URL/IDs. Some com URL/ID configurados
    // ou sem aluno identificado ainda, também não há o que mostrar.
    if (!this.surveyEnabled || !this.surveyUrl || !this.surveyId || !this.user.id) {
      return
    }
    if (this.wasDismissed()) {
      return
    }
    setTimeout(() => {
      this.isOpen = true
      // Marca como "já exibido" assim que abre, não só ao fechar: o iframe do
      // Google Forms é de outro domínio, então não dá pra saber se o aluno
      // respondeu. Sem isso, quem responde sem clicar no X veria o popup nas
      // próximas páginas de novo.
      this.markAsShown()
    }, SHOW_DELAY_MS)
  },
  methods: {
    wasDismissed() {
      try {
        return window.localStorage.getItem(this.storageKey) === '1'
      } catch (e) {
        return false
      }
    },
    markAsShown() {
      try {
        window.localStorage.setItem(this.storageKey, '1')
      } catch (e) {
        // localStorage indisponível (ex.: modo privado); só fecha nesta sessão
      }
    },
    dismiss() {
      this.isOpen = false
    },
  },
}
